import type { ModelName } from "@/endlaFunctions/customTypings/ecTypes";
import type { SubsurfacePaneKey } from "@/endlaFunctions/customTypings/layoutManagerTypes";
import type { NodeIn, TElement, Value } from "@udecode/plate";

export type ECPlateElementParams = {
  ecId: string;
  ecType: SubsurfacePaneKey;
  model: ModelName | undefined;
  title: string;
};
/**
 * EC Element plugin
 */

export const ELEMENT_EC = "ec";

export interface TECElement extends TElement {
  id: string;
  params: ECPlateElementParams;
  height?: number;
  align?: "left" | "center" | "right";
  hidden?: boolean;
}

export function isEcElement(node: NodeIn<Value>): node is TECElement {
  return node.type === ELEMENT_EC;
}

export const ELEMENT_TALLY_TEMPLATES = "tallyTemplates";
